/**
 * Load tune site options from API (related-tunes score + metadata dropdowns).
 */

import {
  DEFAULT_TUNE_METADATA_FIELD_OPTIONS,
  mergeTuneMetadataFieldOptions,
} from '../constants/tuneMetadataFieldOptions';

export const DEFAULT_RELATED_TUNES_MIN_SCORE = 15;

let cache = null;
let loadPromise = null;

function fallbackOptions() {
  return {
    relatedTunesMinScore: DEFAULT_RELATED_TUNES_MIN_SCORE,
    tuneMetadataFieldOptions: { ...DEFAULT_TUNE_METADATA_FIELD_OPTIONS },
  };
}

export async function fetchTuneSiteOptions(force = false) {
  if (!force && cache) return cache;
  if (!force && loadPromise) return loadPromise;

  loadPromise = fetch('/api/content/tune-site-options', { cache: 'no-store' })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (!data || typeof data !== 'object') {
        cache = fallbackOptions();
        return cache;
      }
      const min = parseFloat(data.relatedTunesMinScore);
      cache = {
        relatedTunesMinScore:
          Number.isFinite(min) && min >= 0 ? min : DEFAULT_RELATED_TUNES_MIN_SCORE,
        tuneMetadataFieldOptions: mergeTuneMetadataFieldOptions(
          data.tuneMetadataFieldOptions
        ),
      };
      return cache;
    })
    .catch(() => {
      cache = fallbackOptions();
      return cache;
    })
    .finally(() => {
      loadPromise = null;
    });

  return loadPromise;
}

export function getRelatedTunesMinScore(options) {
  const n = parseFloat(options?.relatedTunesMinScore);
  return Number.isFinite(n) && n >= 0 ? n : DEFAULT_RELATED_TUNES_MIN_SCORE;
}

export function passesRelatedTuneScore(tune, minScore) {
  const min = getRelatedTunesMinScore({ relatedTunesMinScore: minScore });
  return !tune?.score || tune.score >= min;
}

export function filterRelatedTunesByScore(tunes, minScore) {
  return (tunes || []).filter((t) => passesRelatedTuneScore(t, minScore));
}

/** Invalidate client cache after admin saves new options. */
export function invalidateTuneSiteOptionsCache() {
  cache = null;
  loadPromise = null;
}
